module.exports = __webpack_public_path__ + "img/jixiangwu.a1de2b1e.png";